import React , { useState , useEffect } from 'react'
import {collection, getFirestore, onSnapshot } from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import { Routes , Route, Navigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Personal from './personal';
import Nav from './nav';
import Progress from './progress';
import Deleted from './deleted';
import Delayed from './delayed'
import Finished from './finished';
import AddTask from './AddTask';
import UserName from './UserName';

function App() {
  const [name , setName] = useState('')
  const [nav , setNav] = useState('/notes')
  const [todos , setTodos] = useState([])


  useEffect(() => { 
    // const user = prompt('Enter Your Name:' , `${window.localStorage.getItem("Name")}`)

    onSnapshot(colRef , snapshot => {
      setTodos(snapshot.docs.map(doc => ({id:doc.id, ...doc.data()})))
    })

  }, []);
  const firebaseConfig = {
    apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
    authDomain: "to-do-list-app-7aa20.firebaseapp.com",
    projectId: "to-do-list-app-7aa20",
    storageBucket: "to-do-list-app-7aa20.appspot.com",
    messagingSenderId: "388979404562",
    appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
  };
// init services
const db = getFirestore()
// collection Ref
const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)

const app = initializeApp(firebaseConfig)


  return (
    <React.Fragment>
      <UserName />
      <Nav />
      <Routes>
        <Route path='/notes/' element={<Personal name ={window.localStorage.getItem("Name")} targets= {todos} />} >
          <Route path ='/notes/addtask' element={<AddTask name ={name} />} />
        </Route>
        <Route path='/progress' element={<Progress name ={name} targets={todos} />} />
        <Route path='/deleted' element={<Deleted name ={name} targets={todos} />} />
        <Route path='/delayed' element={<Delayed name ={name} targets={todos} />} />
        <Route path='/finished' element={<Finished name ={name} targets={todos} />} />
        <Route path='/' element={<Navigate to={nav} />} />
      </Routes>
    </React.Fragment>
  )
}

export default App